module.exports = __webpack_public_path__ + "static/img/cartlogo.002dcda.png";